export const layoutClassNames = Object.freeze({
  pageContainer: 'logto_page-container',
  mainContent: 'logto_main-content',
  customContent: 'logto_custom-content',
  brandingHeader: 'logto_branding-header',
});
